import React, { useEffect, useState } from "react";
import { MDBCol, MDBContainer, MDBRow } from "mdb-react-ui-kit";
import axios from "axios";
// config
import configData from "../../../config/config.json";
// components
import MetaTagsBusinessOwners from "../../../components/meta-tags-seo/MetaTagsBusinessOwners";
import Sidbarbusiness from "../../../components/business-dashboard/sidbar/Sidbarbusiness";
import HeaderMobile from "../../../components/business-dashboard/sidbar/HeaderMobile";
import CommentBusiness from "../../../components/business-dashboard/CommentBusiness/CommentBusiness";

import Delete from "../../../images/register-business/delete.png";
import boxMassage from "../../../images/end user/postbox.png";

const BusinessOption = (props) => {
  const [render, setRender] = useState(false);

  const [dataCom, setdataCom] = useState(false);

  const [Unread, setUnread] = useState([{}]);
  const [Read, setRead] = useState([
    {},
    // {
    //   id: 1,
    //   title: "رستوران گیشنیز",
    //   desc1: "شما به این کسب‌وکار امتیاز 5 داده‌اید",
    //   CommentDate: " در تاریخ 23 جولای 2022",
    //   Fullname: "نوشته شده توسط زهرا امیری",
    //   CommentBody:"It's a nice, sturdy little stand for a headset. The metal is actually stronger than I expected it to be, and there's rubbe where it sits on the desk and where the headband of the headset rests on the stand, which It's a nice, sturdy little stand for a headset. The metal is actually stronger than I expected it to be, and there's rubbe where it sits on the desk and where the headband of the headset rests on the stand, which isIt's a nice, sturdy little stand for a headset. The metal is actually stronger than I expected it to be, and there's rubbe where it sits on the desk and where the headband of the headset rests on the stand, which isIt's a nice, sturdy little stand for a headset. The metal is actually stronger than I expected it to be, and there's rubbe where it sits on the desk and where the headband of the headset rests on the stand, which isIt's a nice, sturdy little stand for a headset. The metal is actually stronger than I expected it to be, and there's rubbe where it sits on the desk and where the headband of the he",Rate: "4",
    // },
    // {
    //   id: 3,
    //   title: "رستوران گیشنیز",
    //   desc1: "شما به این کسب‌وکار امتیاز 5 داده‌اید",
    //   time: "نوشته شده در ونکوور در تاریخ 23 جولای 2022",
    //   text: "It's a nice, sturdy little stand for a headset. The metal isactually stronger than I expected it to be, and there's rubbe where it sits on the desk and where the headband of the headset",
    //   Rate: "3",
    // },
    // {
    //   id: 4,
    //   title: "رستوران گیشنیز",
    //   desc1: "شما به این کسب‌وکار امتیاز 5 داده‌اید",
    //   time: "نوشته شده در ونکوور در تاریخ 23 جولای 2022",
    //   text: "It's a nice, sturdy little stand for a headset. The metal isactually stronger than I expected it to be, and there's rubbe where it sits on the desk and where the headband of the headset",
    //   Rate: "2",
    // },
  ]);

  // this 2 satae for Meta Tags
  const [MTagsCome, setMTagsCome] = useState(false);
  const [MetaData, setMetaData] = React.useState({});

  //api header
  const headerMeta = {
    ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
    LangId: 1,
    Page: "business-reviews",
    Authorization: "Bearer " + getCookie("token"),
  };

  //api header
  const header = {
    ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
    LangId: 1,
    Bizid: getCookie("BizId"),
    // Bizid: 164,
    Authorization: "Bearer " + getCookie("token"),
  };

  useEffect(() => {
    setdataCom(false);
    let OwnerIdCookie = getCookie("OwnerId");
    if (!OwnerIdCookie) {
      props.history.push({
        pathname: "/login",
      });
    } else if (render) {
      axios
        .get(configData.API_DOMAIN + "/api/v1/MetaTags/businessOwner", {
          headers: headerMeta,
        })
        .then((response) => {
          if (response.data.isSuccess) {
            setMTagsCome(true);
            setMetaData(response.data.data);
          }
        })
        .catch((error) => {
          // alert(error);
        });
      axios
        .get(
          configData.API_DOMAIN +
            `/api/v1/Businesses/${getCookie("BizUuid")}/dashboard-reviews`,
          {
            headers: header,
          }
        )
        .then((response) => {
          if (response.data.isSuccess) {
            setRead(response.data.data.readReview);
            setUnread(response.data.data.unReadReview);
            setdataCom(true);
          }
        })
        .catch((error) => {
          // alert(error);
        });
    }
  }, [render]);

  //   getCookie
  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  let windowWidth = "00";
  if (typeof window !== "undefined") {
    // Code that relies on the window object
    windowWidth = window.innerWidth;
  } else {
    windowWidth = "00";
  }

  return (
    <>
      {MTagsCome ? <MetaTagsBusinessOwners data={MetaData} /> : ""}

      {windowWidth < 768 ? <HeaderMobile setRender={setRender} /> : ""}
      <div className="margin-0 d-flex bg_business_grey">
        <div className="  d-none d-md-block">
          {windowWidth > 767 ? <Sidbarbusiness setRender={setRender} /> : ""}
        </div>

        <MDBContainer className="bg_business_grey">
          {dataCom ? (
            (Unread.length > 0 ||
              (!(Unread.length > 0) && !(Read.length > 0))) && (
              <MDBRow className="">
                <MDBCol size="12">
                  <div>
                    <p className="text_img_bus">دیدگاه‌ها</p>
                  </div>
                  <div className="container_img_bus_content_ping h_auto_business pb-4 ">
                    <div>
                      <p className="header_text_bus_message">
                        دیدگاه‌ خوانده نشده
                      </p>
                    </div>
                    <div className="mt_60_bus mb-2">
                      {" "}
                      <CommentBusiness dataCom={Unread} datacome2={dataCom} />
                    </div>
                  </div>
                </MDBCol>
              </MDBRow>
            )
          ) : (
            <MDBRow className="">
              <MDBCol size="12">
                <div>
                  <p className="text_img_bus">دیدگاه‌ها</p>
                </div>
                <div className="container_img_bus_content_ping h_auto_business pb-4 ">
                  <div>
                    <p className="header_text_bus_message">
                      دیدگاه‌ خوانده نشده
                    </p>
                  </div>
                  <div className="mt_60_bus mb-2">
                    <CommentBusiness dataCom={Unread} datacome2={dataCom} />
                  </div>
                </div>
              </MDBCol>
            </MDBRow>
          )}
          {dataCom ? (
            Read.length > 0 && (
              <MDBRow>
                <MDBCol size="12">
                  <div className="box_tow_message h_auto_business pb-4">
                    <div>
                      <p className="header_text_bus_message">
                        دیدگاه‌ خوانده شده
                      </p>
                    </div>
                    <div className="mt_60_bus ">
                      <CommentBusiness dataCom={Read} datacome2={dataCom} />
                    </div>
                  </div>
                </MDBCol>
              </MDBRow>
            )
          ) : (
            <MDBRow>
              <MDBCol size="12">
                <div className="box_tow_message h_auto_business pb-4">
                  <div>
                    <p className="header_text_bus_message">
                      دیدگاه‌ خوانده شده
                    </p>
                  </div>
                  <div className="mt_60_bus ">
                    <CommentBusiness dataCom={Read} datacome2={dataCom} />
                  </div>
                </div>
              </MDBCol>
            </MDBRow>
          )}
        </MDBContainer>
      </div>
    </>
  );
};

export default BusinessOption;
